import {defineStore} from 'pinia';
import {ref} from "vue";
import {api} from "boot/axios";

export const authenticationStore = defineStore('auth', () => {
  const credentials = ref(null)
  const accessToken = ref(null)
  const refreshToken = ref(null)
  const isAuthenticated = ref(false)
  const headers = ref({headers: "content-type: application/json",})


  async function login() {
    await api.post("/api/token/", credentials.value,
      headers.value).then(resp => {
      accessToken.value = resp.data.access;
      refreshToken.value = resp.data.refresh;
      isAuthenticated.value = true;
      api.get("/api/user/", {
        headers: {
          "accept": "application/json",
          "Authorization": "Bearer " + accessToken.value
        }
      }).then(response => {
        console.log('vous êtes connecté')
        console.log(response)
      })
    })
  }

  async function refreshTokenFn() {
    await api.post("/api/token/refresh", {refresh: refreshToken.value}, headers.value)
      .then(resp => {
        accessToken.value = resp.data.access;
      })
      .catch(err => {
        console.error("Failed to refresh token", err);
        // Maybe log out the user here, since their refresh token has expired/failed.
      });
  }

  async function logout() {
    accessToken.value = null;
    refreshToken.value = null;
    isAuthenticated.value = false;
  }

  return {credentials, login, accessToken, refreshToken, logout, isAuthenticated}
})
